<template>
  <div
    v-if="!input.deleted"
    class="container-item">
    <div class="item">
      <BaseInputSelector
        v-model="input.empId"
        :loading="loading"
        :options="employeeOptions"
        :validateForm.sync="input.validateForm"
        :disabled="disabled"
        :createAble="false"
        @add="handleAddItem"
        @remove="handleRemoveValueItem"
      />
    </div>
    <div class="item wages">
      <BaseInputNumber
        v-model="input.wageAmount"
        :disabled="true"
      />
    </div>
    <div
      v-for="(item, index) in insertColumns"
      :key="index"
      class="item insert-column"
    >
      <BaseInputNumber
        v-model="conditionValue[item.conditionId]"
        :disabled="disabled || item.disabled"
      />
    </div>
    <div class="item net">
      <BaseInputNumber
        v-model="input.net"
        :disabled="true"
      />
    </div>
    <div
      v-if="!disabled"
      class="item delete">
      <BaseButton
        :disabled="disabled"
        className="btn-block border-gray"
        @click="onClickRemove"
      >
        <i class="far fa-trash-alt"/>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { toNumber } from '@/helpers'
import { PAYSLIP_CONDITION_TYPE } from '@/helpers/enum'
import { cloneDeep } from 'lodash'

export default {
  props: {
    value: Object,
    index: Number,
    conditions: Array,
    conditionIds: Array,
    employees: Array,
    selectedEmployeeIds: Array,
    disabled: Boolean,
  },

  data () {
    return {
      input: {
        empId: null,
        name: null,
        wageAmount: null,
        net: null,
        conditions: [],
        deleted: false,
        conditionsDynamic: true,
        validateForm: null,
      },
      conditionValue: {},
      loading: false,
    }
  },

  computed: {
    insertColumns () {
      const empWageAmount = this.empInfo && this.empInfo.wageAmount || 0
      const ids = cloneDeep(this.conditionIds)
      ids.sort()
      return ids.map((id) => {
        const item = this.conditions.find((cond) => cond.conditionId === id)
        return {
          ...item,
          disabled: item.type !== PAYSLIP_CONDITION_TYPE.BASIC,
        }
      })
    },
    employeeOptions () {
      return this.employees.map((emp) => {
        return {
          text: emp.name,
          value: emp.empId,
          disabled: this.selectedEmployeeIds.includes(emp.empId),
        }
      })
    },
    empInfo () {
      if (!this.input.name) {
        return this.employees.find((item) => item.empId === this.input.empId)
      }
      return this.input
    },
  },

  watch: {
    'input.empId': {
      handler: function (newVal) {
        let wageAmount = 0
        let empName = null
        if (newVal) {
          wageAmount = this.empInfo.wageAmount === null ? 0 : this.empInfo.wageAmount
          empName = this.empInfo.name
        }
        this.input.name = empName
        this.input.wageAmount = wageAmount
        this.setConditionValue()
      },
      deep: true,
    },
    'input': {
      handler: function (newVal) {
        this.updateNet()
        this.$emit('input', newVal)
      },
      deep: true,
    },
    'conditionValue': {
      handler: function (newVal) {
        this.updateNet()
        this.updateInputConditions()
      },
      deep: true,
    },
    'conditionIds': {
      handler: function (newVal) {
        this.updateNet()
        this.updateInputConditions()
        this.setConditionValue()
      },
      deep: true,
    },
  },

  created () {
    if (!this.value) {
      this.$emit('input', this.input)
    } else {
      this.input = cloneDeep(this.value)
    }
    this.setConditionValue()
  },

  mounted () {
    this.$emit('update:validateForm', this.input.validateForm)
  },

  methods: {
    handleAddItem (text) {
      // console.log('text', text)
      // this.loading = true
      //
      // setTimeout(() => {
      //   const id = new Date().toISOString()
      //   this.options.push({ text, value: id })
      //   this.loading = false
      //   this.empId = id
      // }, 3000)
    },
    handleRemoveValueItem () {
      this.input.wageAmount = 0
      for (const id of Object.keys(this.conditionValue)) {
        this.conditionValue[id] = 0
      }
      this.$nextTick(() => {
        this.input.conditions = []
        this.input.net = 0
      })
    },
    convertCodeToString (data, replaceValue) {
      if (!data) return null
      let str = data
      const inputMatches = data.match(/{{(.*?)}}/gi)
      if (inputMatches) {
        for (const input of inputMatches) {
          const codeMatches = data.match(/{{(.*?)}}/i)
          const fullCode = codeMatches[0]
          const code = codeMatches[1]
          str = str.replaceAll(fullCode, replaceValue)
        }
        return str
      } else {
        return data
      }
    },
    getEmpConditionAmount (item) {
      const empWageAmount = toNumber(this.empInfo && this.empInfo.wageAmount)
      if (item.type === PAYSLIP_CONDITION_TYPE.BASIC) {
        return 0
      }
      if (item.condition.variable === 'wages') {
        if (item.condition.operator === '>') {
          if (empWageAmount > item.condition.value) {
            let convert = this.convertCodeToString(item.condition.iftrue, empWageAmount)
            return eval(convert)
          } else {
            let convert = this.convertCodeToString(item.condition.iffalse, empWageAmount)
            return eval(convert)
          }
        } else if (item.condition.operator === '<') {
          if (empWageAmount < item.condition.value) {
            let convert = this.convertCodeToString(item.condition.iftrue, empWageAmount)
            return eval(convert)
          } else {
            let convert = this.convertCodeToString(item.condition.iffalse, empWageAmount)
            return eval(convert)
          }
        } else {
          if (empWageAmount == item.condition.value) {
            let convert = this.convertCodeToString(item.condition.iftrue, empWageAmount)
            return eval(convert)
          } else {
            let convert = this.convertCodeToString(item.condition.iffalse, empWageAmount)
            return eval(convert)
          }
        }
      }
      return 0
    },
    updateNet () {
      if (!this.input.empId) return
      const conditionValue = this.insertColumns.reduce((acc, cur) => {
        if (this.conditionIds.includes(cur.conditionId)) {
          const inputValue = toNumber(this.conditionValue[cur.conditionId])
          if (cur.isIncrement) {
            acc += inputValue
          } else {
            acc -= inputValue
          }
        }
        return acc
      }, 0)
      this.input.net = toNumber(this.empInfo.wageAmount) + toNumber(conditionValue)
    },
    updateInputConditions () {
      this.input.conditions = this.conditionIds
        .map((conditionId) => {
          const item = this.conditions.find((cond) => cond.conditionId === conditionId)
          if (this.input.conditionsDynamic) {
            return {
              conditionId: conditionId,
              name: item.name,
              amount: this.conditionValue[conditionId],
              isIncrement: item.isIncrement,
              isEditable: item.type === 'basic',
            }
          }
          const origin = this.input.conditions.find((cond) => cond.conditionId === conditionId)
          if (origin) {
            return {
              conditionId: conditionId,
              name: origin.name,
              amount: this.conditionValue[conditionId],
              isIncrement: origin.isIncrement,
              isEditable: origin.isEditable,
            }
          }
          return {
            conditionId: conditionId,
            name: item.name,
            amount: this.conditionValue[conditionId],
            isIncrement: item.isIncrement,
            isEditable: item.type === 'basic',
          }
        })
    },
    setConditionValue () {
      for (const conditionId of this.conditionIds) {
        const condition = this.conditions.find((cond) => cond.conditionId === conditionId)
        let empWageAmount = 0
        if (this.input.empId) {
          if (this.input.conditionsDynamic) {
            empWageAmount = this.getEmpConditionAmount(condition)
          } else {
            const origin = this.input.conditions.find((cond) => cond.conditionId === conditionId)
            if (origin) {
              empWageAmount = origin.amount
            }
          }
        }
        if (this.conditionValue[conditionId] === undefined) {
          this.$set(this.conditionValue, conditionId, empWageAmount)
        } else {
          this.conditionValue[conditionId] = empWageAmount
        }
      }
    },
    onClickRemove () {
      this.$emit('remove', this.index)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BasePaySlipEmployeeItem.vue